import { STORY_SOURCE, story } from '@/content/storyBuilder'

// The fifteenth written page. Everything below comes from the three-part
// full-page capture of digitopia.co/customers/serenas-part-of-gl-events/ sent
// on 2026-08-28 — "tastamam şekilde, aynısını, tıpkısını tasarla" — with the
// three pictures on it.
//
// Its shape is the reference's, and the reference is the plainest of the
// fifteen: the congress hall in the header where the mark would otherwise be,
// the standfirst as the grey band, the office photograph wide underneath it,
// and then four headed sections running straight down the page — no grey
// panels and no two-column sections anywhere, which is what the capture shows
// and so what it gets.
//
// The closing quote is not a `section`: Isıl Gürbüz's words went into
// `content/testimonials/serenas.ts` keyed to this slug, and `StoryBody` draws
// that card — the testimonial template the same request asked for at the foot
// of the page. That card carries no picture: the building collage that stood
// in the portrait slot was taken out on 2026-08-29 ("testimonial tasarımında
// görsel olmasın"), which is what the reference's own card does too.
export const added = story('serenas-part-of-gl-events', 'Serenas (part of GL Events)', {
  doc: '679b9d87-a454-471e-b571-ce368f15bf33-Serenas Group and Digitopia.pdf',
  lede: ['Digitopia shifted us into the digital events space before the pandemic hit.'],
  heroPhoto: {
    src: '/photo/serenas-congress-audience.webp',
    alt: 'A full congress hall seen from the back: rows of delegates on red chairs facing a '
      + 'speaker at the lectern and a lit presentation screen.',
  },
  intro: [
    'Serenas Group has been offering its services since its inception in 1999 by means of its '
    + 'specialized project groups for Meeting, Incentive, Congress, and Event by boosting '
    + 'technology investments and improving its standards while constantly welcoming change '
    + 'and development and never compromising on ethical values.',
    'Serenas Group merged with GL events, a global event organizer operating in 24 countries '
    + 'on five continents with 4.298 employees and a turnover of over €1 billion with an aim '
    + 'to broaden the scope of its current fields of activity and collected its investments '
    + 'and operations under the roof of GL events Turkey in 2011.',
  ],
  photo: {
    src: '/photo/serenas-open-plan-office.webp',
    alt: 'An empty open-plan office at dusk: desks and monitors between glass partitions, '
      + 'with the city visible through the window wall behind them.',
  },
  sections: [
    {
      heading: 'The Need?',
      body: [
        'Serenas, as part of GL Events, is the leading congress and events company in Turkey. '
        + 'Running hundreds of events every year is a huge operational hassle. Improving '
        + 'customer satisfaction becomes ever more difficult due to the saturation in terms of '
        + 'possibilities in terms of hosting, catering, intellectual and entertaining '
        + 'activities.',
        'Therefore, Serenas turned to digital to improve operational efficiency and at the '
        + 'same time advance the customer experience. They needed a comprehensive digital '
        + 'transformation strategy, roadmap, and organise for it. Luckily, they found '
        + 'Digitopia.',
      ],
    },
    {
      heading: 'The Solution',
      body: [
        'Digitopia entered the customer at a very luck time. It was end of 2019. After several '
        + 'interviews with teams, management, owners, business partners, Digitopia also '
        + 'conducted a “Digital Maturity Index” study to define where Serenas is on their '
        + 'journey, where and what they should aim for.',
        'The compilation of all the analysis resulted in a very comprehensive digital '
        + 'transformation strategy, objectives, and roadmap. Timely enough, that Serenas was '
        + 'able to invest in a digital (virtual) events platform before the pandemic hit. '
        + 'Operations digitalised rapidly thru integration, RPA projects, and thru '
        + 'collaboration with start-ups on various fronts.',
      ],
    },
    {
      heading: 'The Benefits',
      body: [
        'Serenas was superbly prepared for the pandemic. The digital transformation served for '
        + 'improved operational excellence; it also advanced the customer experience. But most '
        + 'importantly, they were caught prepared when Covid-19 hit, and were able to switch to '
        + 'virtual events, conferences, and such basically over-night and enabled business '
        + 'resilience, as much as possible for this heavy-impacted industry.',
      ],
    },
    {
      heading: 'Next Steps',
      body: [
        'Digitopia has become the indispensable companion for Serenas’ digital transformation. '
        + 'Continuous program and project management, participating in the steering committee '
        + 'meetings, and annual repetition of the “digital maturity index” helps and will '
        + 'continue to help Serenas to succeed with their digital transformation.',
      ],
    },
  ],
  check:
    'This page’s words were transcribed from a three-part full-page capture of '
    + `${STORY_SOURCE}/serenas-part-of-gl-events/ supplied on 2026-08-28, not from a file we `
    + 'hold, so please proofread it against the source before production — particularly the '
    + 'GL events figures in the opening band (“24 countries”, “4.298 employees”, “over €1 '
    + 'billion”), and three wordings that are the reference’s own and read like slips rather '
    + 'than transcription errors: “at a very luck time”, “roadmap, and organise for it” and '
    + '“they were caught prepared”. Say the word and they can be corrected; they are left '
    + 'exactly as the live page sets them because the request was for the same page. Three '
    + 'deliberate differences of shape, each a template-wide decision rather than this page’s: '
    + 'the header eyebrow reads “Digitopia / Customer Success Story” where digitopia.co reads '
    + '“SUCCESS STORIES”; the headline is the company name; and the reference’s “Download” '
    + 'button under “Next Steps” is here the one “Read the full story (PDF)” button in the '
    + 'header, pointing at the same document. The quote card at the foot is the Hall of Fame '
    + 'template as asked for and now carries no picture, which is what the reference’s own '
    + 'card does (2026-08-29). Her name is set “Isil Gurbuz” because that is how the '
    + 'reference sets it, without its Turkish letters; send the correct spelling and it '
    + 'changes in one place. One production note: both pictures on the page are small '
    + 'originals — 768×432 and 1200×455, which is what the live site serves — so they are '
    + 'drawn at that width and will look soft on a high-density screen until larger files '
    + 'arrive.',
})

/** Its place in the hand-placed order the imported Customers page set. */
export const order = 20
